import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import styles from "./GridItem.module.scss";

export default function GridItem({ 
  children, 
  className = "", 
  ...rest 
}) {
  return (
    <Grid item {...rest} className={`${styles.grid} ${className}`.trim()}>
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};